<template>
  <div>
<!--    <p class="black-title">我的</p>
    <div class="per-bg">
      <img :src="face" class="per-head" @click="upfaceimg" />
      <p class="per-name">{{ Mine.xm }}</p>
      <div class="per-info">
        <img :src="this.Mine.gender == '1' ? '/static/img/male.png' : '/static/img/female.png'" />
        &lt;!&ndash;        <p>{{this.Mine.dateBirth}}</p> &ndash;&gt;
      </div>
      <div class="info-detail">
        &lt;!&ndash;        <div class="info-item">
          <p class="item-name">学校：</p>
          <span>{{this.Identity == '1'? this.Mine.schoolName : this.Mine.school}}</span>
        </div> &ndash;&gt;
        &lt;!&ndash;        <div class="info-item">
          <p class="item-name">院系：</p>
          <span>{{this.Mine.academy}}</span>
        </div> &ndash;&gt;
        <div>
          <div class="info-item" v-if="this.Identity == '2'">
            <p class="item-name">班级：</p>
            <span>{{ this.Mine.bj }}</span>
          </div>
          &lt;!&ndash;          <div class="info-item" v-if="this.Identity == '2'">
            <p class="item-name">入学年份：</p>
            <span>{{this.Mine.inGrade}}</span>
          </div> &ndash;&gt;
          <div class="info-item">
            <p class="item-name">{{ this.Identity == '2' ? '学号：' : '工号：' }}</p>
            <span>{{ this.Identity == '1' ? this.Mine.jobNumber : this.Mine.xh }}</span>
          </div>

        </div>
      </div>
    </div>
    <div v-if="needupface" class="grey-contain" @click="upfaceimg"><p>人脸识别采集</p></div>
        <div class="grey-contain" @click="changpass"><p>修改密码</p></div>
    <div class="grey-contain" @click="exitLog()"><p>注销</p></div>-->
    <section class="aui-flexView">
      <section class="aui-scrollView">
        <div class="aui-take-content">
          <div class="aui-take-content-col">
            <div class="aui-img-logo">
              <img :src="facepicurl" alt="">
            </div>
            <div class="aui-img-text">
              <h2>{{ user.nickName }}{{user.usertype == '01' ?'老师':'同学'}}</h2>
              <p>{{user.school.xxmc}}，{{user.dept.deptName}}</p>
            </div>
            <div class="aui-layout">

              <a v-if="user.unionid != null && user.unionid!=''" href="javascript:;" >
                <h4 @click="jiebangwx">解绑</h4>
                <p>已绑定微信</p>
              </a>
              <a v-if="user.unionid == null || user.unionid==''" href="javascript:;" >
                <p>未绑定微信</p>
              </a>
            </div>
          </div>
        </div>
        <div class="aui-course-list">
          <router-link :to="{ name: 'usermsg' }">
          <a href="javascript:;" class="aui-flex">
            <div class="aui-cou-img">
              <img src="../assets/img/icon-li-002.png" alt="">
            </div>
            <div class="aui-flex-box">
              <p>消息提醒</p>
            </div>
          </a>
          </router-link>
          <router-link v-if="user.usertype == '01'?true:false" :to="{ name: 'paperlq' }">
            <a href="javascript:;" class="aui-flex">
              <div class="aui-cou-img">
                <img src="../assets/img/paperlq.svg" alt="">
              </div>
              <div class="aui-flex-box">
                <p>试卷领取</p>
              </div>
            </a>
          </router-link>
          <a v-if="user.usertype == '02'" href="javascript:;" @click="uploadFaceImg" class="aui-flex">
            <div class="aui-cou-img">
              <img src="../assets/img/facecj.png" alt="">
            </div>
            <div class="aui-flex-box">
              <p>人脸采集</p>
            </div>
          </a>
          <van-loading style="text-align: center" type="spinner" v-if="loading" color="#1989fa" />
          <div class="divHeight"></div>
          <a href="javascript:;" @click="show=true" class="aui-flex">
            <div class="aui-cou-img">
              <img src="../assets/img/xiugaimm.png" alt="">
            </div>
            <div class="aui-flex-box">
              <p>修改密码</p>
            </div>
          </a>
          <a href="javascript:;" @click="exitLog" class="aui-flex">
            <div class="aui-cou-img">
              <img src="../assets/img/icon-li-006.png" alt="">
            </div>
            <div class="aui-flex-box">
              <p>注销登录</p>
            </div>
          </a>
        </div>
      </section>
    </section>
    <mtabbar></mtabbar>
    <van-dialog v-model="show" title="修改密码" :before-close="beforeClose"
                @confirm="handleConfirm"
                show-cancel-button>
      <van-form ref="myform">
      <!-- 输入密码 -->
      <van-field v-model="formmm.oldPassword"
                 type="password"
                 label="旧密码"
                 placeholder="请输入旧密码"
                 :rules="[
            { required: true, message: '请输入旧密码' }
          ]"
      />
      <van-field v-model="formmm.newPassword"
                 type="password"
                 label="新密码"
                 placeholder="必须8位含数字大小写字母"
                 :rules="[
            { required: true, message: '请输入新密码' }
          ]"
      />
      <van-field v-model="formmm.confirmPassword"
                 type="password"
                 label="新密码确认"
                 placeholder="必须8位含数字大小写字母"
                 :rules="[
            { required: true, message: '请输入新密码' }
          ]"
      />
        <van-field v-model="formmm.email" v-show="showemail"
                   type="text"
                   label="邮箱"
                   placeholder="请输入邮箱，用于找回密码。"
                   :rules="[
            { required: showemail, message: '请输入邮箱' }
          ]"
        />
      </van-form>
    </van-dialog>
  </div>
</template>

<script>
  import {Dialog, Notify} from 'vant';
export default {
  data() {
    return {
      needupface:'',
      user: [],
      face: require('../assets/img/person1.png'),
      Identity: 2,
      malepng: require('../assets/img/male.png'),
      femalepng: require('../assets/img/female_1.png'),
      show:false,
      pattern:/(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])[a-zA-Z0-9]{8,18}/,
      regularemail:/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
      formmm:{
        oldPassword:null,
        newPassword:null,
        confirmPassword:null,
        email:null,
      },
      facepicurl:require('../assets/img/user-logo-004.png'),
      loading:false,
      showemail:false,
    };
  },
  created() {
    this.needupface=this.$global.needupface;
/*    this.$ajax.get('/gettrainimg').then(function(res) {
      console.log(res);
      if (res.code == 200) {
        that.face = res.data;
      } else {
      }
    });*/
    //获取用户信息
    let zhat = this;
    this.$ajax.get('/getInfo').then(function(res) {console.log("s"+JSON.stringify(res.user.email))
      if (res.code == 200) {
        zhat.user = res.user;
        if(res.facepic != null && res.facepic !="")
        {
          zhat.facepicurl = res.facepic;
        }
        if(res.user.email == null || res.user.email =="")
        {
          zhat.showemail = true;
        }
      }
    });
  },
  methods: {
    upfaceimg() {
      if(this.needupface){
        let data = '';
        this.$jtp('openCameraFace', data, this.upFace);
      }
    },
    handleConfirm() {
      if(!this.pattern.test(this.formmm.newPassword) || this.formmm.newPassword.length<8)
      {
        Notify({type: 'danger', message: '新密码必须8位含数字大小写字母！'});
        return;
      }
      if (this.formmm.newPassword != this.formmm.confirmPassword) {
        Notify({type: 'danger', message: '两次输入的新密码不一致！'});
        return;
      }
      if(this.showemail){
        if(!this.regularemail.test(this.formmm.email))
        {
          Notify({type: 'danger', message: '邮箱格式不对！'});
          return;
        }
      }

      let oldPassword = this.formmm.oldPassword;
      let newPassword = this.formmm.newPassword;
      let email = this.formmm.email;
      const data = {
        oldPassword,
        newPassword,
        email
      }
      console.log(data)
      this.$refs["myform"]
        .validate()
        .then(() => {
          this.$ajax.put('/system/user/profile/updatePwdapp', data).then(response => {
            if (response.code == 500) {
              this.formmm = {
                oldPassword: null,
                newPassword: null,
                confirmPassword: null,
                email:null,
              }
              Notify({type: 'danger', message: response.msg});
            } else {
              this.show = false; // 在这里手动的关闭弹窗
              Notify({type: 'success', message: "修改成功"});
              // 重置表单
              this.formmm = {
                oldPassword: null,
                newPassword: null,
                confirmPassword: null,
                email:null,
              }
            }
          });
        })
        .catch((err) => {
          console.log(err)
        });
    },
    beforeClose(action, done) {
      if (action === "confirm") {
        return done(false);
      } else {
        // 重置表单
        this.formmm= {
          oldPassword: null,
          newPassword: null,
          confirmPassword: null,
          email:null,
        }
        return done();
      }
    },
    changpass(){
      this.$router.push("/changpass");
    },
    upFace(res) {
      this.face = res;
      this.tishi = '验证中.....';
      let data = new FormData();

      data.append('img', this.face);
      let that = this;
      this.$ajax.post('/uptrainfile', data).then(function(res) {
        if (res.code == 200) {
          that.$toast.success('上传成功');
        } else {
          that.$toast.fail('上传失败');
        }
      });
    },
    jiebangwx(){
      const data = {
        userId:this.user.userId
      }
      let zhat = this;
      this.$ajax.put('/system/user/removeWx',data).then(() => {
        this.user.unionid = '';
        Notify({type: 'success', message:  '解绑成功'});
      });
    }
    ,
    exitLog() {
      Dialog.confirm({
        message: '<span style="color:red;font-size:13px;">确认注销？</span>'
      })
        .then(() => {
          let _this=this;
          this.$ajax.post('/logout', {}).then(function(res) {
            if (res.code == 200) {
              localStorage.clear();
              localStorage.removeItem("Token");
              location.href = '/login?cancellation=1';
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    uploadFaceImg() {
      let input = document.createElement('input')
      input.setAttribute('type', 'file')
      input.setAttribute('capture', 'environment')
      input.setAttribute('accept', 'image/*')
      input.setAttribute('max-count', '1');
      input.setAttribute('max-size', '6000000');
      input.click();
      let that = this;
      input.onchange = function () {
        let file = this.files[0]
        console.log(file);
          //上传后端备齐一个上传表？还是答案提交采取单题模式？
          let data = new FormData();
          data.append('file', file);
          that.loading=true;
          that.$ajax.post('/student/examonline/facepicUploads', data).then(function(res){
            if(res.code==200){
              that.facepicurl = res.picUrl
              that.loading = false;
            }
          });
      }
    },
  }
};
</script>

<style scoped>
  @import url('../assets/css/grzxstyle.css');
</style>



// WEBPACK FOOTER //
// src/components/person.vue